import { render } from "./periods.vue?vue&type=template&id=cbd1f8b6&scoped=true"
import script from "./periods.vue?vue&type=script&lang=js"
export * from "./periods.vue?vue&type=script&lang=js"

import "./periods.vue?vue&type=style&index=0&id=cbd1f8b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd1f8b6"]])

export default __exports__